import React from 'react';
import styled from 'styled-components';

const PEARL_CONNECT_STEP_ACCENT = '#2b4344';

const AccountSetupStepCounterStyled = styled.label`
    .steps {
        color: ${(props) =>
            props.$pearlConnectTheme ? PEARL_CONNECT_STEP_ACCENT : props.theme.colors.primary.base};
    }
    .stepsTitle {
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 1.5px;
    }
`;

function AccountSetupStepCounter(props) {
    const { stepCountText, stepNameText, hideStepCount, pearlConnectTheme } = props;

    return (
        <AccountSetupStepCounterStyled $pearlConnectTheme={pearlConnectTheme}>
            <b className="stepsTitle">
                {!hideStepCount && <span className="steps">{stepCountText}</span>} {stepNameText}
            </b>
        </AccountSetupStepCounterStyled>
    );
}

AccountSetupStepCounter.defaultProps = {
    pearlConnectTheme: false,
};

export { AccountSetupStepCounter };
